import React, {useCallback} from 'react';
import {Modal} from 'react-bootstrap';

import {ModalIdentifiers} from '../../utils/constants';

export interface Props {
    src: string;
    actions: {
        closeModal: (modalId: string) => void;
    };
}

export function IframeModal(props: Props) {
    const {src, actions: {closeModal}} = props;
    const onHide = useCallback(() => {
        closeModal(ModalIdentifiers.IFRAME);
    }, [closeModal]);
    return (
        <Modal
            onHide={onHide}
            dialogClassName='a11y__modal iframe-modal'
            aria-labelledby={ModalIdentifiers.IFRAME + '-label'}
            aria-describedby={ModalIdentifiers.IFRAME + '-hint'}
            enforceFocus={false}
            restoreFocus={false}
            animation={false}
            show={true}
            role='dialog'
            bsSize='lg'
        >
            <Modal.Header
                id={ModalIdentifiers.IFRAME + '-label'}
                closeButton={true}
            />
            <Modal.Body>
                <iframe src={src}/>
            </Modal.Body>
        </Modal>
    );
}
